import { Link, Text } from 'Common';
import PropTypes from 'prop-types';
import { t } from 'Utils/localization/i18next';
import { captureSentry } from 'Utils/sentry';
import styles from './MissingDataNotification.module.scss';

const TAB_BUTTON_SELECTOR = '[aria-controls="tab-button-preferences"]';
const EDIT_BUTTON_ID = 'family-dashboard-communication-preferences-link';

const MissingDataNotificationBanner = props => (
  <div className={styles['missing-data-notification']}>
    <div className={styles['missing-data-notification-content']}>
      <Text bold>{t(props.text)} </Text>
      <Text className={styles['missing-data-notification-action-links']}>
        {props.action && (
          <Link
            bold
            onClick={() => {
              const tabButton = document.querySelector(TAB_BUTTON_SELECTOR);
              tabButton?.click();

              const editButton = document.getElementById(EDIT_BUTTON_ID);
              editButton?.click();

              if (!editButton) {
                captureSentry(
                  `MissingDataNotificationBanner: ${EDIT_BUTTON_ID} cannot be clicked`
                );
              }
            }}
          >
            {t('missingDataNotification.button')}
          </Link>
        )}
      </Text>
    </div>
  </div>
);

MissingDataNotificationBanner.propTypes = {
  text: PropTypes.string.isRequired,
  action: PropTypes.string,
  tabButtonId: PropTypes.string,
  editButtonId: PropTypes.string
};

export default MissingDataNotificationBanner;
